import React, { useEffect, useState } from 'react';
import {
  TextFacet,
  TextFacetItem,
} from '@1po/1po-bff-fe-spec/generated/catalog/references/iam/response/GetIAMReferencesResponse';
import { TFunction } from 'i18next';
import { FilterFuelEfficiencyTag } from 'components/Filter/FilterColorBar';
import { Checkbox, Flex, Text } from 'UI';
import { getLabel } from '../Filter.shared';
import { FILTER_FUEL_EFFICIENCY, FILTER_WET_GRIP, FilterType } from '../Filter.types';

interface DebouncedCheckboxProps {
  facet: TextFacet;
  item: TextFacetItem;
  isDisabled: boolean;
  getTextChecked: (id: string, item: string) => boolean;
  setTextFilter: (id: string, item: string) => void;
  filterType?: FilterType;
  t: TFunction;
}

const DebouncedCheckbox = ({
  facet,
  item,
  isDisabled,
  getTextChecked,
  setTextFilter,
  filterType,
  t,
}: DebouncedCheckboxProps) => {
  const isCheckedInStore = getTextChecked(facet.id, item.label);
  const [isChecked, setIsChecked] = useState(isCheckedInStore);

  useEffect(() => {
    setIsChecked(isCheckedInStore);
  }, [isCheckedInStore]);

  const renderLabel = () => {
    switch (facet.id) {
      case FILTER_FUEL_EFFICIENCY:
      case FILTER_WET_GRIP:
        return (
          <Flex direction={'row'}>
            <Flex minWidth={35}>
              <Text type="base" color="grey35" displayStyle={isDisabled && 'disabled'}>
                {`(${item.numberOfItems})`}
              </Text>
            </Flex>
            <FilterFuelEfficiencyTag label={item.label}>
              <Text type="sm" color="white" displayStyle={isDisabled && 'disabled'}>
                {`${getLabel(t, facet.id, item.label, filterType)}`}
              </Text>
            </FilterFuelEfficiencyTag>
          </Flex>
        );
      default:
        return (
          <Text type="base" color="grey35" displayStyle={isDisabled && 'disabled'}>
            {`${getLabel(t, facet.id, item.label, filterType)} (${item.numberOfItems})`}
          </Text>
        );
    }
  };

  return (
    <Checkbox
      onChange={() => {
        setIsChecked((prev) => !prev);
        setTextFilter(facet.id, item.label);
      }}
      checked={isChecked}
      disabled={isDisabled}
      label={renderLabel()}
    />
  );
};

export default DebouncedCheckbox;
